<template>
    <hm-content>
        <div class="table-panel flex">
            <div>
                <el-radio-group
                        size="small"
                        v-model="tabPosition"
                        @change="switchTab"
                >
                    <el-radio-button
                        label="left"
                    >寄件人信息维护</el-radio-button>
                    <el-radio-button
                        label="center"
                    >商品关键词维护</el-radio-button>
                    <el-radio-button
                        label="right"
                    >表单信息管理</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div style="margin-top: 30px">
            <div class="table-panel flex" style="margin-bottom: 30px;">
                <el-button size="small" type="button" class="mr10" @click="addSenderMethod">新增寄货人</el-button>
                <el-input size="small" class="mr10 flex-end" placeholder="请输入寄件人姓名/手机号"></el-input>
                <el-button  size="small" class="mr10 flex-end" type="button">查询</el-button>
            </div>
            <div>
                <el-table
                        :data="senderMsg"
                        stripe
                        style="width: 100%"
                >
                    <el-table-column
                        header-align="center"
                        align="center"
                        label="序号"
                        type="index"
                        :index="index => index + (currentPage - 1) * pageSize + 1"
                    ></el-table-column>
                    <el-table-column
                            header-align="center"
                            align="center"
                            prop="changeSn"
                            label="编码"
                    ></el-table-column>
                    <el-table-column
                            header-align="center"
                            align="center"
                            prop="changeSn"
                            label="公司名称"
                    ></el-table-column>
                    <el-table-column
                            header-align="center"
                            align="center"
                            prop="changeSn"
                            label="寄件人"
                    ></el-table-column>
                    <el-table-column
                            header-align="center"
                            align="center"
                            prop="changeSn"
                            label="寄件人手机号"
                    ></el-table-column>
                    <el-table-column
                            header-align="center"
                            align="center"
                            prop="changeSn"
                            label="寄件人地址"
                    ></el-table-column>
                    <el-table-column
                            header-align="center"
                            align="center"
                            prop="changeSn"
                            label="操作"
                    >
                        <template>
                            <el-button type="text">编辑</el-button> |<el-button type="text" style="color:red;">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="hm-pagination">
                    <el-pagination
                            background
                            :total="total"
                            @current-change="paging"
                            @size-change="handleSizeChange"
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page="currentPage"
                    ></el-pagination>
                </div>
                <el-dialog
                        title="新增寄件人信息"
                        :visible.sync="addSenderMsgWindow"
                        width="500px"
                >
                    <el-divider style="margin-top: -50px;"></el-divider>
                    <el-form>

                        <el-form-item label="寄件人编码:" :label-width="formLabelWidth">
                            <el-input v-model="addSenderMsg.senderCode" autocomplete="off" placeholder="请输入寄件人编码" size="small"></el-input><span style="color: red">*</span>
                        </el-form-item>
                        <el-form-item label="公司名称:" :label-width="formLabelWidth">
                            <el-input v-model="addSenderMsg.companyName" autocomplete="off" placeholder="请输入公司名称" size="small"></el-input><span style="color: red">*</span>
                        </el-form-item>
                        <el-form-item label="寄件人姓名:" :label-width="formLabelWidth">
                            <el-input v-model="addSenderMsg.senderName" autocomplete="off" placeholder="请输入寄件人姓名" size="small"></el-input><span style="color: red">*</span>
                        </el-form-item>
                        <el-form-item label="寄件人手机号:" :label-width="formLabelWidth">
                            <el-input v-model="addSenderMsg.senderMobile" autocomplete="off" placeholder="请输入寄件人手机号" size="small"></el-input><span style="color: red">*</span>
                        </el-form-item>
                        <el-form-item label="寄件人地址:" :label-width="formLabelWidth">
                            <el-input v-model="addSenderMsg.senderAddress" autocomplete="off" placeholder="请输入寄件人地址" size="small"></el-input><span style="color: red">*</span>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="flex-center">
                        <el-button @click="addSenderMsgWindow = false">取 消</el-button>
                        <el-button type="primary" @click="addSenderMsgWindow = false">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </hm-content>
</template>
<script>
export default {
    data(){
        return{
            addSenderMsgWindow:false,
            tabPosition:'left',
            currentPage: 1,
            pageSize: 10,
            total:0,
            senderMsg:[{}],
            addSenderMsg:{
                senderCode:'',
                companyName:'',
                senderName:'',
                senderMobile:'',
                senderAddress:'',
            },
            formLabelWidth:'120px'
        }
    },
    methods:{
        switchTab(){
            this.currentPage = 1;
        },
        paging(page) {
            this.currentPage = page;
            this.queryList();
        },
        handleSizeChange(size) {
            this.currentPage = 1;
            this.pageSize = size;
            this.queryList();
        },
        addSenderMethod(){
            this.addSenderMsgWindow = true;
        },
    }
}
</script>
<style lang="scss"></style>